import { ListingLayout } from './ListingLayout';
import PropTypes from 'prop-types';
import React from 'react';
import {
    ButtonFooter,
    ExpandButton
} from 'mol-ui';

export const ListPanel = ({
    addButtonText,
    children,
    endValue,
    filterDates,
    filterOptions,
    footer,
    handleAddItem,
    handleFilter,
    handleFilterDates,
    handleSearch,
    handleSearchEnabled,
    onSearchValueChange,
    hideAddItem,
    searchEnabled,
    searchValue,
    showCounter,
    startValue,
    title,
    value,
    width
}) => (
    <ListingLayout
        endValue={ endValue }
        filterDates={ filterDates }
        filterOptions={ filterOptions }
        footer={ footer }
        handleAdd={ handleAddItem }
        handleFilter={ handleFilter }
        handleFilterDates={ handleFilterDates }
        handleSearch={ handleSearch }
        handleSearchEnabled={ handleSearchEnabled }
        hideAddItem={ hideAddItem }
        searchEnabled={ searchEnabled }
        searchValue={ searchValue }
        showCounter={ showCounter }
        startValue={ startValue }
        title={ title }
        value={ value }
        width={ width }
        onSearchValueChange={ onSearchValueChange }
    >
        { children }
        {
            addButtonText &&
            <ButtonFooter>
                <ExpandButton
                    caption={ addButtonText }
                    size={ 120 }
                    onClick={ handleAddItem }
                />
            </ButtonFooter>
        }
    </ListingLayout>
);

ListPanel.propTypes = {
    addButtonText: PropTypes.string,
    children: PropTypes.any,
    endValue: PropTypes.string,
    filterDates: PropTypes.bool,
    filterOptions: PropTypes.array,
    footer: PropTypes.any,
    handleAddItem: PropTypes.func,
    handleFilter: PropTypes.func,
    handleFilterDates: PropTypes.func,
    handleSearch: PropTypes.func,
    handleSearchEnabled: PropTypes.func,
    hideAddItem: PropTypes.bool,
    onSearchValueChange: PropTypes.func,
    searchEnabled: PropTypes.bool,
    searchValue: PropTypes.string,
    showCounter: PropTypes.number,
    startValue: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.bool,
    width: PropTypes.number
};
